<template>
    <section id="subscription-overview" class="h-100">
        <h2 class="d-lg-none display-4">{{$t('co.subscription.overview.title')}}</h2>
        <div class="card">
            <div class="card-body">
                <div class="row" v-if="isLoading">
                    <div class="col-12 col-md-6 col-lg-12">
                        <b-skeleton height="200px" class="w-100"></b-skeleton>
                        <b-skeleton class="mb-1 mt-3" height="1rem" width="50%"></b-skeleton>
                        <b-skeleton class="mb-1" height="1rem" width="40%"></b-skeleton>
                        <b-skeleton class="mb-1" height="1rem" width="55%"></b-skeleton>
                        <b-skeleton class="mb-1 mt-3" height="1rem" width="45%"></b-skeleton>
                        <b-skeleton class="mb-1" height="1rem" width="65%"></b-skeleton>
                        <b-skeleton class="mb-1 mt-3" height="1rem" width="55%"></b-skeleton>
                        <b-skeleton class="mb-1" height="1rem" width="100%"></b-skeleton>
                        <b-skeleton class="mb-1" height="1rem" width="100%"></b-skeleton>
                    </div>
                </div>
                <div class="row" v-if="!isLoading && entry">
                    <div class="col-12 col-md-6 col-lg-12">
                        <b-img :src="getImage" fluid/>
                    </div>
                    <div class="col-12 col-md-6 col-lg-12">
                        <div class="title-box">
                            <p class="font-weight-bold">{{ getTitle }}</p>
                            <p>{{ getBrand }}</p>
                            <b-badge v-if="subscription.type == 'MVS'" class="image-badge" variant="secondary">{{ entry.tier.title }}</b-badge>
                        </div>
                        <ul class="subscription-data mt-3">
                            <li>{{ getAvailabilityText }}</li>
                            <li>{{$t('co.subscription.overview.extra_costs')}} {{ getAdditionalMileageCosts }}</li>
                            <li v-if="getMinAge">{{$t('co.subscription.overview.minimum_age')}} {{ getMinAge }} {{$t('co.subscription.overview.years')}}</li>
                            <li>{{ getPrice }}
                                <span v-if="!withoutTax">{{$t('co.subscription.overview.per_month')}}</span>
                                <span v-else>{{$t('co.subscription.overview.net_per_month')}}</span>
                            </li>
                            <li v-if="!this.$root.whitelabel.isUs()">{{$t('co.subscription.overview.deductible')}} {{ getDamageParticipation }}</li>
                            <li v-if="this.$root.whitelabel.isUs()">{{$t('co.subscription.overview.membership.fee')}} {{ getDamageParticipation }}</li>
                            <li>{{ getMileage }} {{$t('co.subscription.overview.per_month')}}</li>
                            <li>{{ getDuration }} {{$t('co.subscription.overview.months')}} {{ getDurationType }} {{$t('co.subscription.overview.duration')}}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { BSkeleton, BImg, BBadge } from 'bootstrap-vue'
import { gb } from "../../growthbook";
export default {
    name: 'CheckoutSubscriptionOverview',
    components: {
        BSkeleton, BImg, BBadge
    },
    props: {
        isLoading: true,
        entry: null,
        subscription: null,
        isFixed: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        withoutTax() {
            return this.$root.whitelabel.setting('show_price_without_taxes')
        },
        getImage(){
            return this.entry && this.entry.images.length === undefined && this.entry.images.length !== 0 ? this.entry.title_image : this.$root.whitelabel.getDefaultImage()
        },
        getTitle(){
            return this.entry ? this.entry.title : ''
        },
        getBrand(){
            return this.entry ? this.entry.brand.title : ''
        },
        getAvailabilityText(){
            if(gb.isOn("vehicle_availibility_updated")) {
                return this.entry ? this.$t('vehicle.availability.text.' + this.entry.available_text) : ''
            } else {
                return this.entry && this.entry.available_weeks === 1 ? `${this.$t('general.availability.week', {number: this.entry.available_weeks})}` : `${this.$t('general.availability.weeks', {number: this.entry.available_weeks})}`
            }
        },
        getMileage(){
            return this.entry ? `${this.subscription.price_plan.mileage} ${this.$root.whitelabel.getMileageUnit()}` : ''
        },
        getDuration(){
            return this.entry ? `${this.subscription.price_plan.duration}` : ''
        },
        getPrice(){
            const price = this.$root.whitelabel.setting('show_price_without_taxes') ? this.subscription.price_plan.price_without_tax : this.subscription.price_plan.price

            return this.entry ? this.$root.whitelabel.getFormatetPrice(price) : ''
        },
        getAdditionalMileageCosts(){
            if(this.entry) {
                const costs = this.withoutTax ? this.entry.additional_mileage_costs.costs_net : this.entry.additional_mileage_costs.costs
                const taxes = this.withoutTax ? this.$t('general.net') : ''
                return `${this.$root.whitelabel.getFormatetPrice(costs)} ${taxes}`
            }

            return ''
        },
        getMinAge(){
            return (this.entry && this.entry.minimum_age && this.entry.minimum_age.min_age) ?? ''
        },
        getDurationType(){
            if(this.subscription){
                return this.subscription.fixed_duration ? 'fixe' : 'variable'
            }
            return ''
        },
        getDamageParticipation(){
            return this.entry ? this.$root.whitelabel.getFormatetPrice(this.entry.damage_participation.participation) : ''
        },
    }
}
</script>
